export const blockIconsNavigationArrowRight = (
	<span className='material-symbols-outlined'>arrow_right</span>
);
